import { render } from "./EditVirementPage.vue?vue&type=template&id=62dbb343&ts=true"
import script from "./EditVirementPage.vue?vue&type=script&lang=ts"
export * from "./EditVirementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__